import React from 'react';

import './Info.css';

function Info() {
  return <span className="Info">i</span>;
}

export default Info;
